const state = {
  selectedTaskFilter: 0
}

const mutations = {
  updateSelectedTaskFilter (state, selection) {
    state.selectedTaskFilter = selection
  }
}

const getters = {
  selectedTaskFilter: state => {
    return state.selectedTaskFilter
  }
}

export default {
  state,
  mutations,
  getters
}
